// =============================================================================
// EffectResult — port of EffectResult enum from Cards/EffectContext.cs
// =============================================================================

export const EffectResult = {
  Applied: "Applied",
  Intercepted: "Intercepted",
  Failed: "Failed",
  Skipped: "Skipped",
} as const;

export type EffectResult = (typeof EffectResult)[keyof typeof EffectResult];
